import { UserFeedbackActions } from 'actions'
import { AnalyticsUtils } from 'utils'
import { FeedbackForm } from 'common-frontend'

import './userFeedback.scss'

class UserFeedback extends React.Component {
  static propTypes = {
    isEnjoying: React.PropTypes.bool,
    willReview: React.PropTypes.bool,
    willFeedback: React.PropTypes.bool,
    feedbackDismissed: React.PropTypes.bool.isRequired,
  }

  componentDidMount() {
    AnalyticsUtils.feedbackViewed()
  }

  handleClickedYes() {
    AnalyticsUtils.feedbackYesClicked()
    UserFeedbackActions.enjoying(true)
  }

  handleClickedNotReally() {
    AnalyticsUtils.feedbackNotReallyClicked()
    UserFeedbackActions.dismissed(true)
    UserFeedbackActions.enjoying(false, true)
  }

  handleClickedOkaySurePositive(question) {
    AnalyticsUtils.feedbackOkaySureClicked(question)
    UserFeedbackActions.review(true)
  }

  handleClickedNoThanksPositive(question) {
    AnalyticsUtils.feedbackNoThanksClicked(question)
    UserFeedbackActions.review(false)
  }

  render() {
    if (
      this.props.feedbackDismissed === false &&
      this.props.isEnjoying === null
    ) {
      return (
        <FeedbackForm
          key="feedback-step-1"
          className="userfeedback-b"
          question="Are you enjoying Plug in SEO?"
          buttonTextYes="Yes, I am"
          buttonTextNo="Not Really"
          onAnswer={answer => {
            if (answer === 'yes') {
              this.handleClickedYes()
            } else {
              this.handleClickedNotReally()
            }
          }}
        />
      )
    } else if (
      this.props.feedbackDismissed === false &&
      this.props.isEnjoying === true
    ) {
      const question =
        "Great! Do you have a minute to leave us a review?"

      return (
        <FeedbackForm
          question={question}
          key="feedback-step-2"
          className="userfeedback-b"
          buttonTextYes="Sure, I have a minute"
          buttonTextNo="No, thanks"
          onAnswer={answer => {
            if (answer === 'yes') {
              this.handleClickedOkaySurePositive(question)
            } else {
              this.handleClickedNoThanksPositive(question)
            }
          }}
        />
      )
    } else {
      // default
      return null
    }
  }
}

export default UserFeedback



// WEBPACK FOOTER //
// ./app/components/userfeedback/UserFeedback.js